<h2>{{ "upload-source" | transloco }}</h2>

<div id="container">
  <div>
    <div class="flex-grow"></div>
    <div class="lbl-container">
      <label>{{ "source-type" | transloco }}</label>
    </div>
    <div #dropDown class="ui search selection dropdown">
      <input class="search" autocomplete="off" />
      <div class="text"></div>
      <div class="menu"></div>
      <i class="chevron down icon"></i>
    </div>
  </div>

  <div [hidden]="!showSubtype" class="subtype">
    <div class="flex-grow"></div>
    <div class="lbl-container">
      <label>{{ "subtype" | transloco }}</label>
    </div>
    <div #subTypeDropDown class="ui search selection dropdown">
      <input class="search" autocomplete="off" />
      <div class="text"></div>
      <div class="menu"></div>
      <i class="chevron down icon"></i>
    </div>
  </div>

  <div>
    <div class="flex-grow"></div>
    <div>
      <div
        id="file-upload"
        title="{{
          !sourceId ? 'Please select a source from the dropdown' : undefined
        }}"
      >
        <input
          type="file"
          #sourceFileUpload
          id="list-upload-btn"
          (change)="initFile($event.target.files)"
          [ngClass]="{ disabled: !isUploadEnabled() }"
        />
      </div>
    </div>
  </div>

  <div>
    <div class="flex-grow"></div>

    <div title="{{ !sourceFile ? 'Please upload a source file' : undefined }}">
      <div
        (click)="bulkUpload()"
        id="upload-btn"
        class="ui primary background button"
        [ngClass]="{
          loading: isLoading,
          disabled: !isUploadEnabled() || !sourceFile
        }"
      >
        {{ "upload" | transloco }}
      </div>
    </div>
  </div>
</div>

<div #uploadModal id="upload-modal" class="ui tiny modal">
  <div class="icon modal-close close"></div>
  <div
    class="icon"
    [ngClass]="{
      'green-success': !bulkAddSourceAnswer?.error,
      'red-error': bulkAddSourceAnswer?.error
    }"
  ></div>

  <div class="content">
    <h3>
      {{ bulkAddSourceAnswer?.message }}
      {{ bulkAddSourceAnswer?.error && "Incorrect file setup" }}
    </h3>

    <p>{{ bulkAddSourceAnswer?.error?.message }}</p>
  </div>

  <div class="actions">
    <div class="ui primary background button approve">
      {{ "ok" | transloco }}
    </div>
  </div>
</div>

@if (sourceId && showAppendOrReplace && uploadModeAcceptType) {
<div class="upload-mode-radio">
  <p>{{ "upload-mode" | transloco }}</p>
  <div style="padding: 5px">
    <input
      type="radio"
      name="uploadMode"
      [value]="'append'"
      (change)="updateUploadMode('append')"
      [checked]="isAppendOrReplace === 'append'"
      class="upload-mode"
      style="width: auto"
    />
    <span>
      {{ config.tenant === tenants.FR ? "Add New Data" : "Append Data" }}</span
    >
  </div>
  <div style="padding: 5px">
    <input
      type="radio"
      name="uploadMode"
      [value]="'replace'"
      (change)="updateUploadMode('replace')"
      [checked]="isAppendOrReplace === 'replace'"
      class="upload-mode"
      style="width: auto"
    />
    <span> {{ "replace-data" | transloco }}</span>
  </div>
</div>
}
